import React, { Component } from 'react';
import {SessionContext} from './SessionContext.js';
import LoginForm from './LoginForm.js';

class HomeView extends Component {
    static contextType = SessionContext;

    render() {
        let loginDesktop = null;
        let loginMobile = null;

        if (!this.context.isLoggedIn && this.context.isReady) {
            loginDesktop = <div className="home-login-desktop"><LoginForm /></div>;
            loginMobile = <div className="home-login-mobile"><LoginForm /></div>;
        }

        return <div className="home-view">
            {loginDesktop}
            {loginMobile}

            <h1>What is NslMail?</h1>            

            <p>NslMail offers an alternative way to reduce spam in your inbox. Instead of giving out your real email address to inquiring websites, hand out an NslMail alias, masking your personal address and providing a tracking mechanism to help you identify which websites are sending you spam.</p>
            <p>By using a separate NslMail alias for every website you visit, it becomes easy to determine who is violating privacy agreements and selling your address to spammers. You have the choice of turning each alias off completely or locking it down so you only receive email from whitelisted sources.</p>
            <p>NslMail requires discipline to use effectively – intended for technical users who want granular control over email exposure.</p>
            <br/>

            {!this.context.isLoggedIn &&
            <div>
            <a href="/new-account">
                <img src="/images/signup.jpg" alt="Signup" style={{cursor: 'pointer'}} />
            </a>
            <br/><br/>
            </div>
            }

            <h1>Benefits of using NslMail</h1>
            <ul>
                <li>Keep your inbox free of spam</li>
                <li>Never worry about sharing your personal address with untrustworthy sites.  Maintain control of your email identity</li>
                <li>Keep using your existing email account &amp; software. NslMail is standards compliant – works with any POP3/IMAP client or webmail service.</li>
                <li>Bookmarklet to allow easy access to your aliases</li>
                <li>Long-lived aliases, not disposable – build reputation over time</li>
                <li>Granular control – disable individual aliases or restrict to whitelisted sources</li>
            </ul>
            </div>
        }
  }

  export default HomeView;